import { brandImage } from "@/mocks/editorialImages";
import Reveal from "./Reveal";

const milestones = [
  { icon: "ri-shield-check-line", title: "事实优先", desc: "先交叉核实，再整理入库" },
  { icon: "ri-time-line", title: "全量时间线", desc: "不剪断、不省略关键节点" },
  { icon: "ri-scales-3-line", title: "多方平衡", desc: "尽量呈现各方真实视角" },
  { icon: "ri-eye-off-line", title: "隐私保护", desc: "不公开投稿人个人信息" },
];

const testimonials = [
  {
    name: "阿瓜在冲浪",
    role: "吃瓜爱好者",
    star: 5,
    text: "以前看热点总是一头雾水，反转都跟不上。在这里看一篇「来龙去脉」，整个瓜的来头一下就清楚了，时间线特别清楚。",
  },
  {
    name: "深夜观察员",
    role: "关注 3 年",
    star: 5,
    text: "难得有一家愿意把事件捋顺、把不确定信息标出来的站点，不是一味带节奏，理性又完整，已经成了我的习惯。",
  },
  {
    name: "老瓜农",
    role: "退坑老天涯人",
    star: 5,
    text: "找到以前那味「娓娓道来」的感觉了。旧瓜新瓜都能按分类翻到，档案库真是越做越像样。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="section-wrap">
        <Reveal>
          <div className="text-center">
            <p className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
              <span className="h-px w-6 bg-primary-600"></span> ABOUT US
              <span className="h-px w-6 bg-primary-600"></span>
            </p>
            <h2 className="font-serif-editorial mt-3 text-3xl font-black text-foreground-950 md:text-4xl">
              关于天涯吃瓜
            </h2>
            <p className="mx-auto mt-4 max-w-2xl leading-8 text-foreground-600">
              我们是一群愿意「把瓜吃明白」的编辑与研究员。创建天涯吃瓜，是想在喧嚣的网络声浪里，
              为每一个热点事件留下一份可追溯、可理解、尽量客观的完整档案。
            </p>
          </div>
        </Reveal>

        {/* principles */}
        <div className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {milestones.map((m, i) => (
            <Reveal key={m.title} delay={i * 60}>
              <div className="flex h-full flex-col items-center rounded-2xl border border-background-200 bg-background-50 p-6 text-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-600 text-xl text-white">
                  <i className={m.icon}></i>
                </span>
                <h3 className="mt-4 font-bold text-foreground-900">{m.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-500">{m.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-background-200">
              <img src={brandImage.img} alt={brandImage.alt} className="h-72 w-full object-cover md:h-80" />
            </div>
          </Reveal>
          <Reveal delay={80}>
            <div>
              <h3 className="font-serif-editorial text-2xl font-black text-foreground-950">
                我们的发展理念
              </h3>
              <p className="mt-4 leading-8 text-foreground-600">
                成立以来，我们坚持「事件梳理与来龙去脉全记录」的定位，把碎片化的八卦还原为有结构的档案。
                我们不制造热点，也不煽动对立，而是希望提供一份经得起推敲的「事实地图」，让每个人都能在信息迷雾中
                快速理清脉络。
              </p>
              <p className="mt-4 leading-8 text-foreground-600">
                从娱乐圈到网络热点、商业圈到社会议题，我们持续追踪、滚动更新。无论你关心的是正在发酵的新瓜，
                还是早被遗忘的旧瓜，这里都有一份为你整理好的完整记录。
              </p>
              <div className="mt-6 flex items-center gap-4 border-t border-background-200 pt-6">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <p className="text-sm text-foreground-600">
                  读者综合评分 <span className="font-bold text-foreground-900">4.9</span> / 5
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* testimonials */}
        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 70}>
              <figure className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: t.star }).map((_, k) => (
                    <i key={k} className="ri-star-fill"></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-[15px] leading-7 text-foreground-700">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                    <i className="ri-user-3-line"></i>
                  </span>
                  <div>
                    <p className="font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}